<template>
  <div>
    <el-dialog
      :visible="dialogShow"
      :show-close="false"
      custom-class="pc-dialog-wrapper audit-diglog-wrapper"
      width="468px"
    >
      <div slot="title" class="header-title">
        <span class="title-text">{{ $t('Fleet_optimizaton__Xudd') || "" }}</span>
        <el-popover
          placement="right-start"
          ref="popover"
          width="244"
          popper-class="pc-popper-wrapper"
          :popper-options="popperOptions">
          <div class="popper-title-text"><img-v3 :src="require('../../images/icon_notice@2x.png')" /><span>{{ $t('Fleet_optimizaton__DreP') }}</span></div>
          <p>{{ $t('Fleet_optimizaton__eeJT') }}</p>
          <div style="text-align: right; margin: 0">
            <el-button size="mini" @click="cancelClose">{{ $t('Fleet_optimizaton__sgvv') }}</el-button>
            <el-button type="primary" size="mini" @click="closeDialog" :class="`el-button-${country}`">{{ $t('Fleet_optimizaton__tQRM') }}</el-button>
          </div>
        </el-popover>
        <span v-popover:popover class="title-close-wrapper">
          <img-v3
            class="title-close"
            :src="require('../../images/icon-close-fleet@2x.png')"
          />
        </span>
      </div>
      <component
        :is="getCom"
        :audit-config="auditConfig"
        :idx="idx"
        @form-update="formUpdate"
        @setAuditConfig="setAuditConfig"
        :cm="true"
        :is_finished="is_finished"
        :is_ocr="is_ocr"
        :page_type="page_type"
        :dialog-style="page_style"
        :can-upload="canUpload"
      ></component>
      <!-- <span>{{ alertInfo.desc || "" }}</span> -->
      <!-- <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogShow = false">{{
          alertInfo.btn || $t("确认")
        }}</el-button>
      </span> -->
    </el-dialog>
  </div>
</template>
<script>
// import UploadSelect from "../base/upload-select";
import Upload from "../base/Upload";
import UploadNew from "../../page/upload-new";
import SelectPhoto from "../base/select-photo/select-photo";
import detailMultiUpload from '../base/select-photo/detail-multi-upload';
import MultiUpload from '../base/multi-upload.vue';
import UploadPdf from '../base/upload-pdf.vue';


export default {
  name: "typeCard",
  props: [
    "formItem",
    "idx",
    "is_ocr",
    "page_style",
    "page_type",
    "is_finished",
    "canUpload",
  ],
  data() {
    let auditConfig = this.formItem || {}
    return {
      isOpened: false,
      dialogShow: false,
      auditConfig,
      confirmPopVisible: true,
      popperOptions: { boundariesElement: 'body' }
    };
  },
  mounted() {},
  components: {
    Upload,
    UploadNew,
    SelectPhoto,
    detailMultiUpload,
    MultiUpload,
    UploadPdf
  },
  computed: {
    getCom() {
      let itemType = this.auditConfig.type;
      console.log(itemType)
      return {
        photo: Upload,
        "select-photo": SelectPhoto,
        "photo_new": UploadNew,
        "inner-input": detailMultiUpload,
        "multi-photo": MultiUpload,
        'photo_pdf': UploadPdf,
      }[itemType];
    },
    country() {
      let up = new URLSearchParams(location.search)
      return up.get('location_country')
    }
  },
  methods: {
    // getCom(auditConfig) {
    //   let itemType = auditConfig.type;
    //   return {
    //     photo: Upload,
    //     "select-photo": SelectPhoto
    //   }[itemType];
    // },
    setAuditConfig(config) {
      console.log(config)
      this.auditConfig = config;
    },
    cancelClose() {
      this.$refs.popover.doClose();
    },
    closeDialog() {
      // this.confirmPopVisible = true
      this.$refs.popover.doClose();
      this.dialogShow = false
      this.auditConfig = this.formItem
    },
    formUpdate() {},
  },
};
</script>
<style lang="scss">
.audit-diglog-wrapper {
  height: 600px;
  .el-dialog__body {
    height: 554px;
    overflow: scroll;
    box-sizing: border-box;
  }
}
</style>


